import { useTranslation } from 'react-i18next';

export const ErrorAlert = ({ message }: { message: string }) => {
  const { t } = useTranslation(['router']);
  return (
    <div
      className=" tw-bg-red-100 tw-border-solid tw-border-l-4  tw-border-red-500 tw-text-red-700 tw-p-4 tw-rounded-md"
      role="alert"
      data-testid="error-alert"
    >
      <p className="tw-font-bold">{t('errors.title')}</p>
      <p>{message}</p>
    </div>
  );
};
